import React, { useState, useEffect } from "react";
import * as apicall from '../../components/Apicall';
import { IoArrowBack } from "react-icons/io5";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { FaSearch } from "react-icons/fa";
import { Form, InputGroup, DropdownButton, Dropdown } from 'react-bootstrap';
import '../../App.css'
import DatePicker from "react-datepicker";
import Loader from "../../components/Loader";

const vendor_payout =[
    "Yes",
    "No"
]

const VendorPayments = () => {
      const location = useLocation();
 const [allBookings, setAllBookings] = useState([]); 
const [bookings, setBookings] = useState([]);    
const [dateFilter, setDateFilter] = useState(null);
const [showDatePicker, setShowDatePicker] = useState(false);
const [loader, setLoader] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
const [filteredBookings, setFilteredBookings] = useState([]);
    const [services, setServices] = useState([]);
        const [vendors, setVendor] = useState([]);  
const [serviceFilter, setServiceFilter] = useState(null);
const [vendorFilter, setVendorFilter] = useState(null);
const [payoutFilter, setPayoutFilter] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [form, setForm] = useState({
    vendor_payout: "",
    vendor_reference: "",
    payment_date: "",
    payment_amount:"",
    reference_id:""
  });
const [sortConfig, setSortConfig] = useState({
  key: null,
  direction: "asc", 
});
const handleSort = (key) => {
  let direction = "asc";

  if (sortConfig.key === key && sortConfig.direction === "asc") {
    direction = "desc";
  }

  setSortConfig({ key, direction });

  const sorted = [...bookings].sort((a, b) => {
    let valA = a[key];
    let valB = b[key];

    // Booking ID (number)
    if (key === "booking_id") {
      valA = Number(valA);
      valB = Number(valB);
    }

    // Service Date
    if (key === "serviceDate") {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    // Strings
    if (typeof valA === "string") valA = valA.toLowerCase();
    if (typeof valB === "string") valB = valB.toLowerCase();

    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  });

  setBookings(sorted);
};
const renderArrow = (key) => {
  if (sortConfig.key === key) {
    return (
      <span className="sort-icon">
        {sortConfig.direction === "asc" ? "▲" : "▼"}
      </span>
    );
  }

  return (
    <span className="sort-icon">
      ▲▼
    </span>
  );
};



const today = new Date();

// Default end = today
const defaultEnd = new Date(today);

// Default start = 30 days ago
const defaultStart = new Date(today);
defaultStart.setDate(today.getDate() - 30);

const formatDate = (date) => {
  // Accept Date object or string
  if (!date) return "";
  const d = new Date(date);
  return isNaN(d.getTime()) ? "" : d.toISOString().split("T")[0];
};


const [startDate, setStartDate] = useState(formatDate(defaultStart));
const [endDate, setEndDate] = useState(formatDate(defaultEnd));

        const navigate = useNavigate();

  useEffect(() => {
    fetchBookings();
  }, []);

const fetchBookings = async (start , end) => {
  const start_str = formatDate(start);
    const end_str = formatDate(end);
  try {
    const startStr = formatDate(start_str|| startDate);
    const endStr = formatDate(end_str || endDate);

    let url = "get_all_bookings";

    if (startStr && endStr) {
      url += `?startDate=${startStr}&endDate=${endStr}`;
    }

    const res = await apicall.get(url);
    setAllBookings(res.data);
    setBookings(res.data);
  } catch (e) {
    toast.error(e.message.replace("Error:", ""));
  }
};
const clearAllFilters = () => {
  const defaultStartDate = formatDate(defaultStart);
  const defaultEndDate = formatDate(defaultEnd);

  setServiceFilter(null);
  setVendorFilter(null);
  setPayoutFilter(null);
  setDateFilter(null);
  setSearchTerm("");
  setStartDate(defaultStartDate);
  setEndDate(defaultEndDate);

  fetchBookings(defaultStartDate, defaultEndDate);
};




  const handleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

 const handleBulkUpdate = async () => {
  try{
    setLoader(true)
 const payload = selectedIds.map((id) => {
    return {
      booking_id: id,
      vendor_reference: form.vendor_reference,
      vendor_payout: form.vendor_payout,
      payment_date: form.payment_date,
      reference_id:form.reference_id,
      payment_amount:form.payment_amount
    };
  });
console.log(payload,"payload")
const response = await apicall.post(
  { data: payload },
  "update_vendor_payout"
);
  toast.success("Updated successfully!");
  window.location.reload();
  setSelectedIds([]);
  setForm({ vendor_payout: "", vendor_reference: "", payment_date: "",reference_id:"",payment_amount:"" });
  } catch (err) {
     setLoader(false)
      toast.error("Update failed!");
    }
 
};
const handleSearch = () => {
  if (!searchTerm.trim()) {
       setBookings(allBookings);

    return;
  }

  const results = bookings.filter((b) =>
    b.vendor_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  setBookings(results);
};
    const fetchFilters = async () => {
        try {
            const res = await apicall.get('services')
            setServices(res.data);
        } catch (e) {
            toast.error(e)
        }
    };
    const fetchVendors = async () => {
        try {
            const res = await apicall.get('get_vendors')
            setVendor(res.data);
        } catch (e) {
            toast.error(e)
        }
    };

    useEffect(() => {
        fetchFilters();
        fetchVendors();
    },[]);
  const navigateBack = () => {
    navigate(-1);
  };
const applyFilters = (service, vendor, payout) => {
  let filtered = allBookings;

  if (service) {
    filtered = filtered.filter(
      (item) => item.service_name === service.name
    );
  }

  if (vendor) {
    filtered = filtered.filter(
      (item) => item.vendor_name === vendor.first_name
    );
  }

  // if (payout) {
  //   filtered = filtered.filter(
  //     (item) => (item.payment_amount || "").toLowerCase() === payout.toLowerCase()
  //   );
  // }
    if (payout) {
    if (payout === "(Blank)") {
      filtered = filtered.filter(
        (item) => !item.payment_amount || item.payment_amount.trim() === ""
      );
    } else {
      filtered = filtered.filter(
      (item) => (item.payment_amount || "").toLowerCase() === payout.toLowerCase()
    );
    }
  }

  // if (date) {
  //   const selectedDate = date.toLocaleDateString("en-CA");
  //   filtered = filtered.filter((item) => {
  //     const bookingDate = new Date(item.serviceDate).toLocaleDateString("en-CA");
  //     return bookingDate === selectedDate;
  //   });
  // }

  setBookings(filtered);
};


const calculateSummary = () => {
  const selectedRows = bookings.filter((b) =>
    selectedIds.includes(b.booking_id)
  );

  const totalVendorPayable = selectedRows.reduce(
    (sum, row) => sum + (parseFloat(row.total_amount) || 0),
    0
  );
console.log(totalVendorPayable,"totalVendorPayable")

  const totalCashReceived = selectedRows.reduce(
    (sum, row) => {
      const paymentStatus = (row.payment_status || '').toLowerCase(); // Assuming field is 'payment'; make comparison case-insensitive
      const isCashPayment = paymentStatus === "cash on service" || paymentStatus === "cash paid";
      return sum + (isCashPayment ? (parseFloat(row.ServiceAmount) || 0) : 0);
    },
    0
  );
console.log(totalCashReceived,"totalCashReceived")

   let balancePayment = totalVendorPayable - totalCashReceived;
console.log(balancePayment,"balancePayment")

  if (totalVendorPayable === 0 && totalCashReceived > 0) {
    balancePayment = 0;
  }

  return { totalVendorPayable, totalCashReceived, balancePayment };
};
const vendor_payout_details = ["Yes", "No", "(Blank)"];




  return (
    
    <div className="container my-4 p-3 bg-white rounded-3">

  <div className="mb-3 d-flex align-items-center">
    <h1 className="sub-heading mb-0">Vendor Payout Details</h1>
  </div>

    <div className="col-md-4 mb-4">
 <InputGroup>
  <Form.Control
    type="search"
    placeholder="Search by vendor name"
    value={searchTerm}
    onChange={(e) => {
      const value = e.target.value;
      setSearchTerm(value);

      if (value.trim() === "") {
        setBookings(allBookings);
      }
    }}
    style={{ minWidth: "200px" }}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSearch();
      }
    }}
  />
  <InputGroup.Text
    className="primaryBackground"
    onClick={handleSearch}
    style={{ cursor: "pointer" }}
  >
    <FaSearch className="text-white" />
  </InputGroup.Text>
</InputGroup>

</div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                   <div className="d-flex gap-3 align-items-center">
  <DropdownButton
    id="service-filter"
    variant="outline-secondary"
    title={serviceFilter?.name || "Select Service"}
  >
    {services.map((service) => (
      <Dropdown.Item
        key={service.id}
        onClick={() => {
          setServiceFilter(service);
          applyFilters(service, vendorFilter, payoutFilter);
        }}
      >
        {service.name}
      </Dropdown.Item>
    ))}
  </DropdownButton>

  <DropdownButton
    id="vendor-filter"
    variant="outline-secondary"
    title={vendorFilter?.first_name || "Select Vendor"}
  >
    {vendors.map((vendor) => (
      <Dropdown.Item
        key={vendor.id}
        onClick={() => {
          setVendorFilter(vendor);
          applyFilters(serviceFilter, vendor, payoutFilter);
        }}
      >
        {vendor.first_name}
      </Dropdown.Item>
    ))}
  </DropdownButton>

  <DropdownButton
    id="payout-filter"
    variant="outline-secondary"
    title={payoutFilter || "Select Vendor Payout"}
  >
    {vendor_payout_details.map((status) => (
      <Dropdown.Item
        key={status}
        active={status === payoutFilter}
        onClick={() => {
          setPayoutFilter(status);
          applyFilters(serviceFilter, vendorFilter, status);
        }}
      >
         {status === "(Blank)" ? "(Blank)" : status}
      </Dropdown.Item>
    ))}
  </DropdownButton>

</div>

                </div>
                <div className="d-flex gap-4 mb-4 align-items-end w-100 flex-wrap">
                <div>
                    <label htmlFor="startDate" className="form-label">Start Date</label>
                    <input
                        type="date"
                        id="startDate"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="form-control"
                    />
                </div>

                <div>
                    <label htmlFor="endDate" className="form-label">End Date</label>
                    <input
                        type="date"
                        id="endDate"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="form-control"
                    />
                </div>

         <div className="d-flex gap-2 mt-3">
  <button
    className="btn"
    onClick={fetchBookings}
    style={{
      background: "#d01c4c",
      minWidth: "80px",
      height: "40px",
      color: "white"
    }}
  >
    Apply
  </button>

  <button
    className="btn btn-outline-secondary"
    onClick={clearAllFilters}
    style={{ minWidth: "80px", height: "40px" }}
  >
    Clear All
  </button>
</div>

                </div>
            

  <div
    className="table-responsive border rounded mt-5"
    style={{ maxHeight: "400px", overflowY: "auto" }}
  >
  <table className="table table-bordered table-striped w-100 mb-0">
  <thead className="table-light sticky-top">
    <tr>
      <th style={{ width: "50px" }}></th>

      <th
        style={{ cursor: "pointer",width:"5px" }}
        onClick={() => handleSort("booking_id")}
      >
        Booking ID{renderArrow("booking_id")}
      </th>

      <th>Vendor Payout</th>
      <th>Payment Date</th>
      <th>Vendor Reference</th>
      <th>Payment Reference Id</th>
      <th>Payment</th>

      <th
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("first_name")}
      >
        First Name{renderArrow("first_name")}
      </th>

      <th>Phone Number</th>

      <th
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("vendor_name")}
      >
        Vendor Name{renderArrow("vendor_name")}
      </th>

      <th>Service Name</th>
      <th>Service Type</th>
      <th>Service Offering</th>

      <th
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("serviceDate")}
      >
        Service Date{renderArrow("serviceDate")}
      </th>

      <th>Service Time</th>
      <th>Payment Status</th>
      <th>Service Amount</th>
      <th>Service Status</th>
      <th>Vendor Payout Amount</th>
      <th>VAT</th>
      <th>Total Vendor Payout</th>
    </tr>
  </thead>

  <tbody>
    {bookings.length === 0 ? (
      <tr>
        <td colSpan="21" className="text-center">
          No records available
        </td>
      </tr>
    ) : (
      bookings.map((b) => {
        const isSelected = selectedIds.includes(b.booking_id);
        return (
          <tr
            key={b.booking_id}
            style={{
              backgroundColor: isSelected ? "#f0f8ff" : "transparent",
            }}
          >
            <td>
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => handleSelect(b.booking_id)}
              />
            </td>

            <td>{b.booking_id}</td>
            <td>{b.payment_amount}</td>
            <td>{b.payment_date}</td>
            <td>{b.vendor_reference}</td>
            <td>{b.payment_reference_id}</td>
            <td>{b.payment}</td>
            <td>{b.first_name}</td>
            <td>{b.phone_number}</td>
            <td>{b.vendor_name}</td>
            <td>{b.service_name}</td>
            <td>{b.service_type_name}</td>
            <td>{b.service_offering_name}</td>
            <td>{b.serviceDate}</td>
            <td>{b.service_time}</td>
            <td>{b.payment_status}</td>
            <td>{b.ServiceAmount}</td>
            <td>{b.service_status}</td>
            <td>{b.actual_vendor_amount}</td>
            <td>{b.vendor_payout_with_fee}</td>
            <td>{b.total_amount}</td>
          </tr>
        );
      })
    )}
  </tbody>
</table>

  </div>
{selectedIds.length > 0 && (
  <div className="p-3 mb-4 border rounded bg-light mt-5">
    <h5 className="mb-3">Summary of Records</h5>
    {(() => {
      const { totalVendorPayable, totalCashReceived, balancePayment } = calculateSummary();
      return (
        <div className="row">
          <div className="col-md-4">
            <h1 className="label">Total Vendor Payable Amount:</h1> 
            <p>{totalVendorPayable.toFixed(2)}</p>
          </div>
          <div className="col-md-4">
            <h1 className="label">Total Cash Received:</h1>
            <p> {totalCashReceived.toFixed(2)}</p>
          </div>
          <div className="col-md-4">
            <h1 className="label">Balance Payment Amount:</h1>
            <p> {balancePayment.toFixed(2)}</p>
          </div>
        </div>
      );
    })()}
  </div>
)}
<div className="mt-4 p-3 border rounded">
  <div className="row g-3 align-items-center">
    
    <div className="col-md-4">
      <label className="form-label">Vendor Payout</label>
      <select
          className="form-select"
          value={form.vendor_payout}
          onChange={(e) =>
            setForm({ ...form, vendor_payout: e.target.value })
          }        >
          <option value="">Select vendor payout</option>
          {vendor_payout?.map((f) => (
            <option key={f.id} value={f}>
              {f}
            </option>
          ))}
        </select>
    </div>

    <div className="col-md-4">
      <label className="form-label">Payment Date</label>
      <input
        type="date"
        className="form-control"
        value={form.payment_date}
        onChange={(e) =>
          setForm({ ...form, payment_date: e.target.value })
        }
      />
    </div>

        <div className="col-md-4">
      <label className="form-label">Vendor Reference</label>
      <input
        type="text"
        className="form-control"
        value={form.vendor_reference}
        onChange={(e) =>
          setForm({ ...form, vendor_reference: e.target.value })
        }
      />
    </div>
     <div className="col-md-4">
      <label className="form-label">Payment Reference ID</label>
      <input
        type="text"
        className="form-control"
        value={form.reference_id}
        onChange={(e) =>
          setForm({ ...form, reference_id: e.target.value })
        }
      />
    </div>
     <div className="col-md-4">
      <label className="form-label">Payment amount</label>
      <input
        type="text"
        className="form-control"
        value={form.payment_amount}
        onChange={(e) =>
          setForm({ ...form, payment_amount: e.target.value })
        }
      />
    </div>

   <div className="col-md-3 d-flex justify-content-end">
  <button
    className="btn Button primaryBackground text-white d-flex align-items-center justify-content-center"
    onClick={handleBulkUpdate}
    style={{
      minWidth: "100px",
      fontSize: "14px",
      borderRadius: "6px",
      marginTop:"25px"
    }}
  >
        {loader ? <Loader style={{ height: '18px', width: '25px' }} /> : 'Save'}

  </button>
</div>

  </div>
</div>

</div>


  );
};

export default VendorPayments;
